import React, { FunctionComponent } from 'react';
import { useInView } from 'react-intersection-observer';

import Text from 'components/Text/Text';
import { fadeInUpMotion } from 'utils/styles/animations';

import * as S from './GroupList.styles';

export interface ItemsProps {
  name: string;
  values: string;
}

export interface GroupListProps {
  items: ItemsProps[];
}

const defaultProps: Partial<GroupListProps> = {
  items: [],
};

const GroupList: FunctionComponent<GroupListProps> = ({ items }) => {
  const [wrapperRef, inView] = useInView({ threshold: [0.25, 0.5, 0.75] });

  return (
    <S.GroupsList ref={wrapperRef} role="list">
      {items.map(({ name, values }: ItemsProps, listIndex: number) => {
        const formattedValues = values?.split(',') || [];

        return (
          <S.Group
            key={`section-list-${listIndex}`}
            role="listitem"
            initial={fadeInUpMotion.initial}
            animate={inView ? fadeInUpMotion.animate : fadeInUpMotion.initial}
            transition={{ delay: 0.3 * (listIndex + 1), duration: 0.3 }}
          >
            <S.GroupItem
              initial={fadeInUpMotion.initial}
              animate={inView ? fadeInUpMotion.animate : fadeInUpMotion.initial}
              transition={{
                delay: 0.15 * (listIndex + 1),
                duration: 0.3,
              }}
            >
              <S.TextContainer>
                <Text text={name} size="heading5" />
              </S.TextContainer>

              <S.GroupItemListWrapper>
                <S.GroupItemList>
                  {formattedValues.map((item: string, itemIndex: number) => (
                    <Text
                      key={`section-list-item-${itemIndex}`}
                      text={item}
                      size="heading5"
                      initial={fadeInUpMotion.initial}
                      animate={
                        inView ? fadeInUpMotion.animate : fadeInUpMotion.initial
                      }
                      transition={{
                        delay: 0.3 * (itemIndex + 1),
                        duration: 0.6,
                      }}
                    />
                  ))}
                </S.GroupItemList>
              </S.GroupItemListWrapper>
            </S.GroupItem>
          </S.Group>
        );
      })}
    </S.GroupsList>
  );
};

GroupList.defaultProps = defaultProps;

export default GroupList;
